import { render } from "./CurrentPlayerReports.vue?vue&type=template&id=34f0084a"
import script from "./CurrentPlayerReports.vue?vue&type=script&lang=js"
export * from "./CurrentPlayerReports.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__